export const en = {
    cancel: 'Cancel',
    'header-hint':
        'Specify the deactivation threshold to continue ad impressions if your shared account runs out of funds. To activate the service, enter a sum within the limits of deferred amount available. Select the payer and payment method. If at the end of the month the shared account balance is less than {limit} {currency}, you will get an invoice for the amount owed, including VAT, based on the data specified. The invoice must be paid within 15 days.',
    'header-hint-no-nds':
        'Specify the deactivation threshold to continue ad impressions if your shared account runs out of funds. To activate the service, enter a sum within the deferred amount available. Select the payer and payment method. If at the end of the month the shared account balance is less than {limit} {currency}, you will get an invoice for the amount owed, without VAT, based on the data specified. The invoice must be paid within 15 days.',
    'header-title': 'Deactivation threshold',
    'no-payment-methods':
        'You cannot set up a deactivation threshold as there are no payment methods available for the selected payer. To solve the problem, {writeToUsLink}.',
    payer: 'Payer',
    'payment-method': 'Payment method',
    'payment-method-limit': 'up to {value} {currency}',
    'switch-off': 'Deactivate',
    'switch-off-limit': 'Deactivation threshold (incl. VAT), {currency}',
    'switch-off-limit-hint': 'available threshold: {limit} {currency}',
    'switch-off-limit-no-nds-limit': 'Deactivation threshold (excl. VAT), {currency}',
    'switch-on': 'Activate',
    'write-to-us-link': 'write to us'
};
